import React from 'react';
import { Space, Tag, Typography } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Text } = Typography;

const typeColors = {
    'Dịch vụ': 'blue',
    'Sản phẩm': 'purple',
};

/** Hiển thị thống nhất thông tin nhận diện dịch vụ và ngày chốt trong nội dung phiếu thu. */
const ReceiptItemInfoCell = ({ name, type, serviceId, customerServiceId, selectedAt, children }) => {
    const selectedAtMoment = selectedAt ? moment(selectedAt) : null;
    const selectedDate = type === 'Dịch vụ' && selectedAtMoment?.isValid()
        ? selectedAtMoment.format('DD/MM/YYYY')
        : '';

    return (
        <div style={{ minWidth: 180, lineHeight: 1.45 }}>
            <Text strong style={{ display: 'block', color: '#262626' }}>
                {name || 'Nội dung chưa xác định'}
            </Text>
            {(type || selectedDate) && (
                <Space size={6} wrap style={{ marginTop: 3 }}>
                    {type && (
                        <Tag
                            color={typeColors[type]}
                            style={{ marginRight: 0, fontSize: 11, lineHeight: '18px' }}
                        >
                            {type}
                        </Tag>
                    )}
                    {/* {type === 'Dịch vụ' && serviceId && (
                        <Text type="secondary" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                            ServiceID: {serviceId}
                        </Text>
                    )} */}
                    {type === 'Dịch vụ' && customerServiceId && (
                        <Text type="secondary" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                            ID: {customerServiceId}
                        </Text>
                    )}
                    {selectedDate && (
                        <Text type="secondary" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                            <CalendarOutlined style={{ marginRight: 4 }} />
                            Ngày chốt: {selectedDate}
                        </Text>
                    )}
                </Space>
            )}
            {children}
        </div>
    );
};

export default ReceiptItemInfoCell;
